export default "__VITE_ASSET__rWj$7_Cu__"